var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 25,
    viewBox: "0 0 35 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6C0 2.6863 2.68629 0 6 0H25C28.3137 0 31 2.68629 31 6V14.1121C31 17.403 28.3506 20.0751 25.0684 20.1118C24.0312 21.9609 22.207 23.3802 20 24.0001V20.1121H6C2.68629 20.1121 0 17.4258 0 14.1121V6ZM25 5H6V7H25V5ZM6 9H25V11H6V9ZM25 13H6V15H25V13Z",
    fill: "#52ACBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 25C32.3137 25 35 22.3137 35 19C35 15.6863 32.3137 13 29 13C25.6863 13 23 15.6863 23 19C23 22.3137 25.6863 25 29 25Z",
    fill: "#FF892A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8729 18.013L28.1911 20.719L32.2883 16.5128",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSuccess);
export default __webpack_public_path__ + "static/media/comment-success.a66cd10d52abc44db2302bc8a0c1a9af.svg";
export { ForwardRef as ReactComponent };